import React from "react";
import { TableBody, TableRow } from "material-ui";
import CustomTableCell from "../controls/CustomTableCell";
import DeleteButton from "../controls/DeleteButton";
import CartBodyNoItems from "./CartBodyNoItems";
import currency from "currency.js";

const CartBody = ({
  cartArray,
  onDeleteCartItem,
  onProductItemSelect,
  onUpdateCartItem
}) => {
  if (cartArray.length === 0) {
    return <CartBodyNoItems />;
  }

  const changeQuantity = (item, amount) => {
    const currentQty = Number(item.qty || 1);
    const newQty = Math.max(1, currentQty + amount);

    const sellingPrice = currency(item.sellingPrice || item.price || 0);
    const totalPrice = sellingPrice.multiply(newQty);

    onUpdateCartItem({
      ...item,
      qty: newQty,
      totalPrice: totalPrice.toString()
    });
  };

  const quantityButtonStyle = {
    width: 26,
    height: 26,
    border: "1px solid #dce7e2",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 15,
    fontWeight: 800,
    cursor: "pointer",
    lineHeight: 1,
    transition: "all 0.15s ease"
  };

  return (
    <TableBody>
      {cartArray.map((n, index) => {
        const image =
          n.images &&
          n.images.length > 0 &&
          n.images[0] &&
          (n.images[0].src || n.images[0].url);

        return (
          <TableRow
            key={n.id}
            style={{
              background: "#ffffff",
              borderBottom: "1px solid #edf2f0",
              transition: "background 0.15s ease"
            }}
          >
            <CustomTableCell
              style={{
                width: 150,
                padding: "12px 8px 12px 12px"
              }}
            >
              <div
                onClick={() => onProductItemSelect(n)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 9,
                  cursor: "pointer"
                }}
              >
                <div
                  style={{
                    width: 42,
                    height: 42,
                    minWidth: 42,
                    borderRadius: 10,
                    background: "#f4f8f6",
                    border: "1px solid #e6eeeb",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  {image ? (
                    <img
                      src={image}
                      alt={n.name || "Product"}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        display: "block"
                      }}
                    />
                  ) : (
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 800,
                        color: "#16845b"
                      }}
                    >
                      {(n.name || "P")
                        .split(" ")
                        .slice(0, 2)
                        .map(word => word.charAt(0))
                        .join("")
                        .toUpperCase()}
                    </span>
                  )}
                </div>

                <div
                  style={{
                    minWidth: 0,
                    overflow: "hidden"
                  }}
                >
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 750,
                      color: "#19352d",
                      lineHeight: "15px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {n.name}
                  </div>

                  <div
                    style={{
                      marginTop: 3,
                      fontSize: 9,
                      color: "#8a9993",
                      fontWeight: 600
                    }}
                  >
                    SKU: {n.sku || n.id}
                  </div>
                </div>
              </div>
            </CustomTableCell>

            <CustomTableCell
              numeric
              style={{
                color: "#16845b",
                fontWeight: 700,
                fontSize: 11
              }}
            >
              {"\u20A6"}
              {Number(n.sellingPrice || n.price || 0).toLocaleString()}
            </CustomTableCell>

            <CustomTableCell numeric>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: 5
                }}
              >
                <button
                  type="button"
                  onClick={() => changeQuantity(n, -1)}
                  style={{
                    ...quantityButtonStyle,
                    background: "#f7f9f8",
                    color: "#52655e"
                  }}
                  title="Decrease quantity"
                >
                  &#8722;
                </button>

                <span
                  style={{
                    minWidth: 22,
                    textAlign: "center",
                    fontWeight: 800,
                    fontSize: 12,
                    color: "#19352d"
                  }}
                >
                  {n.qty}
                </span>

                <button
                  type="button"
                  onClick={() => changeQuantity(n, 1)}
                  style={{
                    ...quantityButtonStyle,
                    background: "#eaf7f1",
                    borderColor: "#bfe4d3",
                    color: "#16845b"
                  }}
                  title="Increase quantity"
                >
                  +
                </button>
              </div>
            </CustomTableCell>

            <CustomTableCell
              numeric
              style={{
                fontWeight: 800,
                color: "#19352d",
                fontSize: 12
              }}
            >
              {"\u20A6"}
              {Number(n.totalPrice || 0).toLocaleString()}
            </CustomTableCell>

            <CustomTableCell
              numeric
              style={{
                width: 42,
                paddingRight: 5
              }}
            >
              <DeleteButton
                onDelete={() => onDeleteCartItem(n)}
              />
            </CustomTableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};

export default CartBody;
